import React from 'react';
import { useTranslation } from 'react-i18next';
import PublicLayout from '../components/PublicLayout';
import './CommonPages.css';

const Updates = () => {
  const { i18n } = useTranslation();
  const tr = i18n.language?.startsWith('tr');

  const updates = tr
    ? [
        {
          version: 'v2.5.0',
          date: '25 Eki 2025',
          type: 'Major',
          changes: [
            'Split tunneling iyileştirmeleri',
            'macOS Sequoia uyumluluğu',
            'Daha sade admin paneli navigasyonu',
            '2FA deneyimi netleştirildi',
          ],
        },
        {
          version: 'v2.4.2',
          date: '15 Eki 2025',
          type: 'Patch',
          changes: [
            'Güvenlik yamaları',
            'Android bağlantı kararlılığı',
            'Kill switch kenar durumları',
          ],
        },
        {
          version: 'v2.4.0',
          date: '1 Eki 2025',
          type: 'Minor',
          changes: [
            'Yeni lokasyon seçenekleri',
            'API dokümantasyon güncellemesi',
            'Bağlantı geçmişi filtreleri',
          ],
        },
        {
          version: 'v2.3.5',
          date: '20 Eyl 2025',
          type: 'Patch',
          changes: [
            'Windows istemci iyileştirmeleri',
            'UI metin ve erişilebilirlik düzenleri',
            'Küçük hata düzeltmeleri',
          ],
        },
      ]
    : [
        {
          version: 'v2.5.0',
          date: '25 Oct 2025',
          type: 'Major',
          changes: [
            'Split tunneling improvements',
            'macOS Sequoia compatibility',
            'Cleaner admin navigation',
            'Clearer 2FA experience',
          ],
        },
        {
          version: 'v2.4.2',
          date: '15 Oct 2025',
          type: 'Patch',
          changes: [
            'Security patches',
            'Android connection stability',
            'Kill switch edge-case fixes',
          ],
        },
        {
          version: 'v2.4.0',
          date: '1 Oct 2025',
          type: 'Minor',
          changes: [
            'Additional location options',
            'API documentation refresh',
            'Connection history filters',
          ],
        },
        {
          version: 'v2.3.5',
          date: '20 Sep 2025',
          type: 'Patch',
          changes: [
            'Windows client polish',
            'UI copy and accessibility tweaks',
            'Minor bugfixes',
          ],
        },
      ];

  return (
    <PublicLayout
      title={tr ? 'Güncellemeler' : 'Updates'}
      subtitle={tr ? 'Üründe ne değişti — sakin bir sürüm geçmişi.' : 'What changed in the product — a calm release history.'}
    >
      <div className="common-page">
        <div className="updates-modern">
          {updates.map((update) => (
            <article className="arc-panel update-modern" key={update.version}>
              <div className="update-modern-head">
                <div>
                  <h3>{update.version}</h3>
                  <p>{update.date}</p>
                </div>
                <span className="update-chip">{update.type}</span>
              </div>
              <ul className="arc-list-plain">
                {update.changes.map((change) => (
                  <li key={change}>{change}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <section className="arc-cta-band">
          <h2>{tr ? 'Haberdar olun' : 'Stay in the loop'}</h2>
          <p>{tr ? 'Önemli sürümler için destek kanalınızı veya satış temsilcinizi kullanın.' : 'For major releases, use your support channel or sales contact.'}</p>
        </section>
      </div>
    </PublicLayout>
  );
};

export default Updates;
